
import React, { useEffect, useContext, useState, useRef, useCallback } from "react";
import { CanvasContext } from "../contexts/CanvasContext";
import anime, { stagger } from "animejs";

import { useLocation } from 'react-router-dom';

import "../styles/canvas.css";
import {
  Button, Box, CircularProgress, IconButton
} from "@mui/material";

import ExplorationTree from "./ExplorationTree";
import LayersPanel from "./LayersPanel";
import NarrativeTimeline from "./NarrativeTimeline";
import OverlayMask from "./OverlayMask";
import AnimationScriptPanel from "./AnimationScriptPanel";
import ConceptScriptPanel from "./ConceptScriptPanel";
import PasteAnimationPanel from "./PasteAnimationPanel";

import {
  Code as CodeIcon,
  Lightbulb,
  ContentPaste
} from '@mui/icons-material';

export default function CanvasPlayground( ) {

  const toggleScriptPanel = () => {
    setShowScriptPanel(!showScriptPanel);
  };

  const toggleTextPanel = () => {
    setShowTextPanel(!showTextPanel);
  };

  const togglePasteAnimationPanel = () => {
    setShowPasteAnimationPanel(!showPasteAnimationPanel);
  }


  const resetCanvasElementsForReplay = async () => {

    layers.forEach(layer => {
      const element = document.getElementById(layer.id);
      if (element) {
        // Reset specific animated properties
        element.style.transform = ''; // Reset transform properties
        element.style.boxShadow = ''; // Reset box-shadow properties
        element.style.opacity = ''; // Reset opacity properties (if animated)
        element.style.transition = ''; // Reset transition properties (if animated)
        element.style.animation = ''; // Reset animation properties (if animated)
        console.log(`Resetting element ${layer.id}`);
      }
    });

    setLayers([...layers]);
  }

  const runPastedAnimation = async (animation_code) => {

    resetCanvasElementsForReplay();

    setAnimationScript(animation_code);

    await executeAnimation(anime, animationScript); // Await the animation execution

    if (animationRef.current) {
      animationRef.current.play();
    }

  }

    // Getting the layout from the user choice in previous LayoutSelection page
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
 
    const canvasRef = useRef(null);
    const [selectedLayer, setSelectedLayer] = useState(null);
    const [layerDetails, setLayerDetails] = useState(null);
    const [showPasteAnimationPanel, setShowPasteAnimationPanel] = useState(false);

    const { conceptSummary, animationRef,
      setLayoutType, loading, overlayMessage,
      isPlayingAnimation, setIsPlayingAnimation,
      showScriptPanel, setShowScriptPanel,
      showTextPanel, setShowTextPanel,
      animationScript, setAnimationScript,
     queryLayoutType, setQueryLayoutType,
      setOverlayMessage, concept, setConcept, layers, setLayers, executeAnimation

    } = useContext(CanvasContext);
    setQueryLayoutType(queryParams.get('type'));



    useEffect(() => {
      setLayoutType(queryLayoutType);
    }, [setLayoutType]);

    return (

      <div ref={canvasRef} id="canvasContainer"
      >

        
        <div className="canvas-flex-container">


        <div
            id="canvas"
          >
            <div className="canvas-overflow-hidden">

              {layers.map((layer, index) => (
                <img
                  key={index}
                  alt={layer.alt || ""}
                  id={layer.id}
                  style={{
                    position: 'absolute',
                    width: layer.width,
                    height: layer.height,
                    left: layer.left,
                    top: layer.top,
                    zIndex: layer.zIndex,
                  }}
                  src={layer.src}
                />
              ))}
            </div>

          </div>

        </div>  

                <PasteAnimationPanel runPastedAnimation={runPastedAnimation} animationScript={animationScript} setAnimationScript={setAnimationScript} onClose={togglePasteAnimationPanel} />



      </div>
    );
  }
